(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404-game"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLostCard(root) {
      if (!root || root.dataset.lcInit) return;
      root.dataset.lcInit = '1';

      var strings = JSON.parse(root.querySelector('[data-role="strings"]').textContent);
      var stage = root.querySelector('[data-role="stage"]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-role="card"]'));
      var cta = root.querySelector('[data-role="cta"]');
      var ctaWin = root.querySelector('[data-role="cta-win"]');
      var title = root.querySelector('[data-role="title"]');
      var sub = root.querySelector('[data-role="sub"]');
      var slots = [0, 1, 2];
      var phase = 'idle';
      var round = 0;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function sleep(ms) {
        return new Promise(function (r) { setTimeout(r, reduced ? 10 : ms); });
      }
      var typeToken = 0;
      function setText(t, s) {
        var token = ++typeToken;
        if (reduced) {
          title.textContent = t;
          sub.textContent = s || ' ';
          return;
        }
        sub.textContent = ' ';
        title.textContent = '';
        title.classList.add('is-typing');
        var i = 1;
        (function step() {
          if (token !== typeToken) return;
          if (i <= t.length) {
            title.textContent = t.slice(0, i);
            i++;
            setTimeout(step, 60);
          } else {
            title.classList.remove('is-typing');
            sub.textContent = s || ' ';
          }
        })();
      }
      function layout() {
        var w = cards[0].offsetWidth;
        var gap = (stage.offsetWidth - w * 3) / 2;
        cards.forEach(function (c, i) {
          c.style.setProperty('--x', slots[i] * (w + gap) + 'px');
          c.style.setProperty('--y', '0px');
        });
      }
      window.addEventListener('resize', layout);

      function swapOnce(speed) {
        var a = Math.floor(Math.random() * 3);
        var b = Math.floor(Math.random() * 3);
        while (b === a) b = Math.floor(Math.random() * 3);
        var w = cards[0].offsetWidth;
        var gap = (stage.offsetWidth - w * 3) / 2;
        var tmp = slots[a]; slots[a] = slots[b]; slots[b] = tmp;
        cards[a].style.transitionDuration = speed + 'ms';
        cards[b].style.transitionDuration = speed + 'ms';
        cards[a].style.zIndex = 2;
        cards[b].style.zIndex = 1;
        cards[a].style.setProperty('--x', slots[a] * (w + gap) + 'px');
        cards[a].style.setProperty('--y', '-14px');
        cards[b].style.setProperty('--x', slots[b] * (w + gap) + 'px');
        cards[b].style.setProperty('--y', '12px');
        return sleep(speed).then(function () {
          cards[a].style.setProperty('--y', '0px');
          cards[b].style.setProperty('--y', '0px');
          return sleep(80);
        });
      }

      function startRound() {
        phase = 'shuffling';
        cta.hidden = true;
        stage.classList.remove('is-pickable');
        cards.forEach(function (c) {
          c.classList.remove('is-faceup', 'is-won');
          c.disabled = true;
        });
        setText(strings.shuffling, '');
        var swaps = Math.min(5 + round * 2, 11);
        var speed = Math.max(420 - round * 45, 220);
        var chain = sleep(620);
        for (var i = 0; i < swaps; i++) {
          chain = chain.then(function () { return swapOnce(speed); });
        }
        chain.then(function () {
          phase = 'pick';
          setText(strings.pickTitle, strings.pickSub);
          stage.classList.add('is-pickable');
          cards.forEach(function (c) { c.disabled = false; });
        });
      }

      function pick(card) {
        if (phase !== 'pick') return;
        phase = 'done';
        stage.classList.remove('is-pickable');
        cards.forEach(function (c) { c.disabled = true; });
        card.classList.add('is-faceup');
        sleep(650).then(function () {
          if (card.classList.contains('is-page')) {
            card.classList.add('is-won');
            setText(strings.winTitle, strings.winSub);
            ctaWin.hidden = false;
          } else {
            cards.filter(function (c) { return c.classList.contains('is-page'); })[0].classList.add('is-faceup');
            setText(strings.loseTitle, strings.loseSub);
            round++;
            cta.textContent = strings.ctaReplay;
            cta.hidden = false;
          }
        });
      }

      cta.addEventListener('click', function () {
        cta.hidden = true;
        if (phase === 'idle') {
          // Première manche : montrer la Page avant de battre les cartes.
          cards[0].classList.add('is-faceup');
          sleep(950).then(function () {
            cards[0].classList.remove('is-faceup');
            return sleep(650);
          }).then(startRound);
        } else {
          cards.forEach(function (c) { c.classList.remove('is-faceup', 'is-won'); });
          sleep(600).then(startRound);
        }
      });
      cards.forEach(function (c) {
        c.addEventListener('click', function () { pick(c); });
      });

      layout();
    }

    function boot() {
      document.querySelectorAll('.lost-card-404').forEach(initLostCard);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
